import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import Svg from "../Svg";
var Icon = function(props) {
    return /*#__PURE__*/ _jsxs(Svg, {
        width: "62",
        height: "62",
        viewBox: "0 0 62 62",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ _jsxs("g", {
                filter: "url(#filter0_d_1_2725)",
                children: [
                    /*#__PURE__*/ _jsx("rect", {
                        x: "11",
                        y: "6",
                        width: "40",
                        height: "40",
                        rx: "12",
                        fill: "#194BFB",
                        shapeRendering: "crispEdges"
                    }),
                    /*#__PURE__*/ _jsxs("g", {
                        clipPath: "url(#clip0_1_2725)",
                        children: [
                            /*#__PURE__*/ _jsx("path", {
                                fillRule: "evenodd",
                                clipRule: "evenodd",
                                d: "M29.5982 17.1682C27.3182 19.0682 26 21.8827 26 24.8504V31H36V24.8504C36 21.8827 34.6818 19.0682 32.4018 17.1683L31.5335 16.4446C31.2244 16.1871 30.7756 16.1871 30.4665 16.4446L29.5982 17.1682ZM31 23.5C31.9205 23.5 32.6667 22.7538 32.6667 21.8333C32.6667 20.9129 31.9205 20.1667 31 20.1667C30.0795 20.1667 29.3333 20.9129 29.3333 21.8333C29.3333 22.7538 30.0795 23.5 31 23.5Z",
                                fill: "white"
                            }),
                            /*#__PURE__*/ _jsx("path", {
                                opacity: "0.48",
                                d: "M22.6667 30.6519C22.6667 29.3331 23.4118 28.1275 24.5913 27.5377L26 26.8334V31H23.0148C22.8226 31 22.6667 30.8441 22.6667 30.6519Z",
                                fill: "white"
                            }),
                            /*#__PURE__*/ _jsx("path", {
                                opacity: "0.48",
                                d: "M39.3333 30.6519C39.3333 29.3331 38.5882 28.1275 37.4087 27.5377L36 26.8334V31H38.9852C39.1774 31 39.3333 30.8441 39.3333 30.6519Z",
                                fill: "white"
                            }),
                            /*#__PURE__*/ _jsx("path", {
                                opacity: "0.48",
                                d: "M28.5 32.6666H33.5C33.5 33.7079 32.9796 34.6802 32.1133 35.2578L31 36L29.8867 35.2578C29.0204 34.6802 28.5 33.7079 28.5 32.6666Z",
                                fill: "white"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("defs", {
                children: [
                    /*#__PURE__*/ _jsxs("filter", {
                        id: "filter0_d_1_2725",
                        x: "0",
                        y: "0",
                        width: "62",
                        height: "62",
                        filterUnits: "userSpaceOnUse",
                        colorInterpolationFilters: "sRGB",
                        children: [
                            /*#__PURE__*/ _jsx("feFlood", {
                                floodOpacity: "0",
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ _jsx("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ _jsx("feOffset", {
                                dy: "5"
                            }),
                            /*#__PURE__*/ _jsx("feGaussianBlur", {
                                stdDeviation: "5.5"
                            }),
                            /*#__PURE__*/ _jsx("feComposite", {
                                in2: "hardAlpha",
                                operator: "out"
                            }),
                            /*#__PURE__*/ _jsx("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 0.0980392 0 0 0 0 0.294118 0 0 0 0 0.984314 0 0 0 0.25 0"
                            }),
                            /*#__PURE__*/ _jsx("feBlend", {
                                mode: "normal",
                                in2: "BackgroundImageFix",
                                result: "effect1_dropShadow_1_2725"
                            }),
                            /*#__PURE__*/ _jsx("feBlend", {
                                mode: "normal",
                                in: "SourceGraphic",
                                in2: "effect1_dropShadow_1_2725",
                                result: "shape"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx("clipPath", {
                        id: "clip0_1_2725",
                        children: /*#__PURE__*/ _jsx("rect", {
                            width: "25",
                            height: "25",
                            fill: "white",
                            transform: "translate(19 13)"
                        })
                    })
                ]
            })
        ]
    });
};
export default Icon;
